<template>
    <span class="number">{{ quantity }}</span>
</template>

<script>
    export default {
        props: ['quantityProp'],

        data() {
          return {
              quantity: this.quantityProp
          }
        },

        mounted() {
            this.$root.$on('calcBasketQuantity', quantity => this.quantity = quantity );
        },
    }
</script>
